import { Button, Icon, useTranslation } from '@testsigma/atoms';

import UploadFileButton from './upload-file-button';
import ModalIcon from './modal-icon';
import TextareaWrapper from './textarea-wrapper';

const ModalContent = ({
  watch,
  handleSubmit,
  getValues,
  formState: { errors },
  onClose,
  loading,
  onSubmit,
  onChangeDescription,
  showFile,
  onFileSelect,
  onFileRemove,
}) => {
  const { t } = useTranslation();

  const renderButtons = () => (
    <div className='w-full text-end mt-6'>
      <Button type='secondary' onClick={onClose} className='mr-3'>
        {t('cancel')}
      </Button>
      <Button
        isDisabled={!!errors?.description || (watch('description')?.length < 50)}
      >
        {loading && (
          <Icon className='text-base animate-spin mr-2' name='loader' />
        )}
        {t('bug_report.title')}
      </Button>
    </div>
  );

  return (
    <form
      className='flex flex-col justify-between h-full w-full'
      onSubmit={handleSubmit(onSubmit)}>
      <div className='flex flex-col'>
        <ModalIcon />
        <h1 className='text-xl font-semibold text-secondary-unique-600 mt-6'>
          {t('agent.report_agent_modal_heading')}
        </h1>
        <TextareaWrapper
          onChange={onChangeDescription}
          value={watch('description')}
          errors={errors}
          description={getValues('description')}
        />
        {showFile && (
          <UploadFileButton
            onFileRemove={onFileRemove}
            onFileSelect={onFileSelect}
            uploadedFileName={watch('fileName')}
          />
        )}
        <p className='text-sm text-secondary-unique-800 mt-6'>
          {t('agent.report_agent_modal_content_1')}
        </p>
        <p className='text-sm text-secondary-unique-800 mt-6'>
          {t('agent.report_agent_modal_content_2')}
        </p>
      </div>
      {renderButtons()}
    </form>
  );
};

export default ModalContent;
